module.exports = __webpack_public_path__ + "img/logos.7606cd01.jpg";